export const textToVideoGenerationSettings = [
  {
    title: "Text To Video Generation",
    subMenu: [
      {
        linkTitle: "Reels, Shorts & Video Ads",
        linkURL: "http://predis.ai/instagram-reels-maker/"
      },
      {
        linkTitle: "E-comm Product Video",
        linkURL: "https://predis.ai/ecommerce-video-maker/"
      },
      {
        linkTitle: "TikTok Videos",
        linkURL: "https://predis.ai/use-cases/tiktok-video-maker/"
      },
      {
        linkTitle: "Instagram Story Maker",
        linkURL: "https://predis.ai/use-cases/instagram-story-maker/"
      }
    ]
  }
];

export const textToCreativesGeneratorSettings = [
  {
    title: "Text To Creatives Generator",

    subMenu: [
      {
        linkTitle: "Social Media Posts",
        linkURL: "https://predis.ai/social-media-post-generator/"
      },
      {
        linkTitle: "E-comm Product Posts",
        linkURL: "https://predis.ai/ecommerce-social-media-post-maker/"
      },
      {
        linkTitle: "AI Meme Generator",
        linkURL: "https://predis.ai/free-ai-tools/ai-meme-generator"
      },
      {
        linkTitle: "Blog to Posts",
        linkURL: "https://predis.ai/blog-to-posts/"
      },
      {
        linkTitle: "Special Day Posts",
        linkURL: "https://predis.ai/special-day-posts/"
      },
      {
        linkTitle: "Quote to Posts",
        linkURL: "https://predis.ai/quotes-to-posts/"
      }
    ]
  }
];
export const pages = [
  {
    title: "Features",
    // icon: <RocketLaunchIcon sx={{ mr: ".5rem" }} />,
    link: "https://predis.ai/features/"
  },
  {
    title: "Free AI Tools",
    // icon: <ElectricBoltIcon sx={{ mr: ".5rem" }} />,
    link: "https://predis.ai/free-ai-tools/"
  }
];
export const hideOptions = [
  "/free-ai-tools/free-hashtag-generator",
  "/free-ai-tools/color-palette-generator",
  "/free-ai-tools/ai-meme-generator",
  "/free-ai-tools/best-photo-picker",
  "/free-ai-tools/video-thumbnail-picker",
  "/free-ai-tools/background-remover",
  "/free-ai-tools/stock-image-search",
  "/free-ai-tools/background-color-changer",
  "/free-ai-tools/tweet-to-image-generator",
  "/free-ai-tools/instagram-username-generator",
  "/free-ai-tools/instagram-feed-maker",
  "/free-ai-tools/youtube-title-generator",
  "/free-ai-tools/product-description-generator",

  "/free-ai-tools/instagram-caption-generator",
  "/free-ai-tools/instagram-bio-generator",
  "/free-ai-tools/tiktok-username-generator",
  "/free-ai-tools/youtube-username-generator",
  "/free-ai-tools/twitter-username-generator",
  "/free-ai-tools/pinterest-username-generator",
  "/free-ai-tools/facebook-username-generator",
  "/free-ai-tools/snapchat-username-generator",
  "/free-ai-tools/threads-username-generator",
  "/free-ai-tools/twitch-gaming-username-generator",
  "/free-ai-tools/facebook-caption-generator",
  "/free-ai-tools/tiktok-caption-generator",
  "/free-ai-tools/pinterest-caption-generator",
  "/free-ai-tools/social-media-caption-generator",
  "/free-ai-tools/podcast-title-generator",
  "/free-ai-tools/blog-title-generator",
  "/free-ai-tools/instagram-threads-post-generator",
  "/free-ai-tools/instagram-notes-generator",
  "/free-ai-tools/linkedin-post-generator",
  "/free-ai-tools/quotes-generator",
  "/free-ai-tools/twitter-bio-generator",
  "/free-ai-tools/pinterest-bio-generator",
  "/free-ai-tools/social-media-bio-generator",
  "/free-ai-tools/facebook-bio-generator",
  "/free-ai-tools/tiktok-bio-generator",
  "/free-ai-tools/linkedin-bio-generator",
  "/free-ai-tools/youtube-channel-description-generator",
  "/free-ai-tools/bumble-bio-generator",
  "/free-ai-tools/tinder-bio-generator",
  "/free-ai-tools/youtube-video-description-generator",
  "/free-ai-tools/tweet-generator",
  "/free-ai-tools/ecommerce-brand-name-generator",
  "/free-ai-tools/ecommerce-brand-slogan-generator",
  "/free-ai-tools/call-to-action-generator",
  "/free-ai-tools/tiktok-hastag-generator"
];
export const solutionOption = [
  {
    title: "For Creators & Coaches",
    // icon: <CalendarMonthIcon sx={{ mr: ".5rem" }} />,
    link: "https://predis.ai/business-coach-social-media-tool/"
  },
  {
    title: "For Agencies",
    // icon: <AccountCircleIcon sx={{ mr: ".5rem" }} />,
    link: "https://predis.ai/social-media-agency-tool/"
  },
  {
    title: "For E-Commerce Stores",
    // icon: <ShoppingCartIcon sx={{ mr: ".5rem" }} />,
    link: "https://predis.ai/ecommerce-stores-social-media-tool/"
  }
];
